import AiSlideIn from '#client/components/AiSlideIn/AiSlideIn';

import FederatedEntry from '../FederatedEntry';

export default function AiSlideInEntry(props) {
  return (
    <FederatedEntry>
      <AiSlideIn {...props} />
    </FederatedEntry>
  );
}
